import { createAction, props } from '@ngrx/store';
import { BulkResponse, SealingElement } from 'src/app/models/sealing-element.model';
import { SealingElementMaintenanceFilter } from '../fromSealingElement.barrel';

const prefix = '[SealingElement MAINTENANCE]';

// the load to return the result for the maintenance screen
export const loadSealingElementsForMaintenance = createAction(`${prefix} load sealing elements`, props<{ skip: number, take: number }>());
export const loadSealingElementsForMaintenanceSuccess = createAction(`${prefix} load sealing elements success`, props<{ data: BulkResponse<SealingElement> }>());
export const loadSealingElementsForMaintenanceFail = createAction(`${prefix} load fail`, props<{ error: any }>());


// this is the update to the filter on the maintenance page
export const updateMaintenanceFilter = createAction(`${prefix} update maintenance filter`, props<{ obj: Partial<SealingElementMaintenanceFilter> }>());
export const toggleOptionOnMaintenanceFilter = createAction(`${prefix} toggle option on maintenance filter`, props<{ fieldName: string, val: any }>());

export const extractDataFromTemplate = createAction(`${prefix} extract info from file`, props<{ file: File }>());
export const extractDataFromTemplateSuccess = createAction(`${prefix} extract info from file success`)
export const extractDataFromTemplateFail = createAction(`${prefix} extract info from file fail`, props<{ error: any }>());

export const exportToExcel = createAction(`${prefix} export selection to excel`);
export const exportToExcelSuccess = createAction(`${prefix} export selection to excel success`);
export const exportToExcelFail = createAction(`${prefix} export selection to excel fail`, props<{ error: any }>());

export const toggleAll = createAction(`${prefix} toggle all selection`);
export const toggleSealingElementSelection = createAction(`${prefix} toggle sealing element selection`, props<{ partNumber: string }>());
export const clearSelection = createAction(`${prefix} clear selection`);
